module.exports = __webpack_public_path__ + "static/img/icon06.099d27c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/culture/icon06.png
// module id = Jc0/
// module chunks = 1